'use client';

import React from 'react';
import { motion } from 'framer-motion';

import { cn } from '@/lib/utils';

interface ShimmerTextProps {
  children: React.ReactNode;
  className?: string;
  baseClassName?: string;
  active?: boolean;
  duration?: number;
}

export function ShimmerText({
  children,
  className,
  baseClassName,
  active = false,
  duration = 1.45,
}: ShimmerTextProps) {
  return (
    <span className={cn('relative inline-block align-top', className)}>
      <span className={cn('block w-fit whitespace-nowrap', baseClassName)}>
        {children}
      </span>
      <motion.span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 block w-fit whitespace-nowrap"
        style={{
          WebkitTextFillColor: 'transparent',
          background:
            'linear-gradient(90deg, transparent 0%, transparent 30%, rgba(255,255,255,0.14) 42%, rgba(255,255,255,0.78) 50%, rgba(255,255,255,0.14) 58%, transparent 70%, transparent 100%)',
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '150% 100%',
        }}
        initial={{
          backgroundPositionX: '110%',
          opacity: 0,
        }}
        animate={
          active
            ? {
                backgroundPositionX: ['110%', '-110%'],
                opacity: [0, 1, 1, 0],
              }
            : {
                backgroundPositionX: '110%',
                opacity: 0,
              }
        }
        transition={{
          duration,
          ease: 'linear',
        }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export default ShimmerText;
